import CookiesHandler from "../Utils/CookiesHandler";
import ConsoleLogger from "../Utils/CookiesHandler";
const context = "User Management";
var UserProfile = (function () {



    var setInstance = function (instance) {
        CookiesHandler.setInstance(instance);
    }

    var setSessionId = function (session_id) {
        CookiesHandler.setSessionId(session_id);
    }

    var setUserId = function (user_id) {
        CookiesHandler.setUserId(user_id);
    }
    var setUserAuthState = function (user_AuthState) {
        CookiesHandler.setUserAuthState(user_AuthState);
    }

    var setIssuedAt = function (issued_at) {
        CookiesHandler.setIssuedAt(issued_at);
    }

    var setRefreshToken = function (refresh_token) {
        CookiesHandler.setRefreshToken(refresh_token);
    }


    var getSessionId = function () {
        var session_id = CookiesHandler.getSessionId();
        return session_id;
    }

   
    var getRefreshToken = function () {
        var refresh_token = CookiesHandler.getRefreshToken();
        return refresh_token;
    }

    var getInstance = function () {
        var instance = CookiesHandler.getInstance();
        return instance;
    }

    var getUserId = function () {
        var user_id = CookiesHandler.getUserId();
        return user_id;
    }

    var getUserAuthState = function () {
        var user_id = CookiesHandler.getUserAuthState();
        return user_id;
    }

    var getIssuedAt = function () {
        var issued_at = CookiesHandler.getIssuedAt();
        return issued_at;
    }

    var logout = function () {
        //logout
       var isLogout =  CookiesHandler.logout();
       
       return isLogout;
    }

    var getCurrentPageId = function (){
        var page_id = CookiesHandler.getCurrentpageId();
        return page_id;
    }



    return {

        getInstance: getInstance,
        setInstance: setInstance,
        setSessionId: setSessionId,
        setRefreshToken: setRefreshToken,
        setUserId : setUserId,
        getSessionId: getSessionId,
        getRefreshToken: getRefreshToken,
        logout: logout,
        getIssuedAt : getIssuedAt,
        getUserId : getUserId,
        setIssuedAt : setIssuedAt,
        getCurrentPageId : getCurrentPageId,
        setUserAuthState,
        getUserAuthState
    }

})();

export default UserProfile;


// WEBPACK FOOTER //
// ./src/Utils/userManagement.js